"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StarRatingComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(StarRatingComponent, _Component);

  function StarRatingComponent() {
    _classCallCheck(this, StarRatingComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(StarRatingComponent).apply(this, arguments));
  }

  _createClass(StarRatingComponent, [{
    key: "onStarClick",
    value: function onStarClick(index, name, e) {
      e.stopPropagation();
      var _this$props = this.props,
          onStarClick = _this$props.onStarClick,
          editing = _this$props.editing;

      if (!editing) {
        return;
      }

      onStarClick && onStarClick(index, name, e);
    }
  }, {
    key: "onStarHover",
    value: function onStarHover(index, name, e) {
      e.stopPropagation();
      var _this$props2 = this.props,
          onStarHover = _this$props2.onStarHover,
          editing = _this$props2.editing;

      if (!editing) {
        return;
      }

      onStarHover && onStarHover(index, name, e);
    }
  }, {
    key: "onStarHoverOut",
    value: function onStarHoverOut(index, name, e) {
      e.stopPropagation();
      var _this$props3 = this.props,
          onStarHoverOut = _this$props3.onStarHoverOut,
          editing = _this$props3.editing;

      if (!editing) {
        return;
      }

      onStarHoverOut && onStarHoverOut(index, name, e);
    }
  }, {
    key: "renderStars",
    value: function renderStars() {
      var _this = this;

      var _this$props4 = this.props,
          name = _this$props4.name,
          starCount = _this$props4.starCount,
          starColor = _this$props4.starColor,
          emptyStarColor = _this$props4.emptyStarColor,
          editing = _this$props4.editing,
          value = _this$props4.value;

      var starStyles = function starStyles(i, value) {
        return {
          "float": 'right',
          cursor: editing ? 'pointer' : 'default',
          color: value >= i ? starColor : emptyStarColor
        };
      }; // populate stars


      var starNodes = [];

      var _loop = function _loop(i) {
        var id = "".concat(name, "_").concat(i);

        var starNodeLabel = _react["default"].createElement("label", {
          key: "label_".concat(id),
          style: starStyles(i, value),
          className: 'dv-star-rating-star ' + (value >= i ? 'dv-star-rating-full-star' : 'dv-star-rating-empty-star'),
          htmlFor: id,
          onClick: function onClick(e) {
            return _this.onStarClick(i, name, e);
          },
          onMouseOver: function onMouseOver(e) {
            return _this.onStarHover(i, name, e);
          },
          onMouseLeave: function onMouseLeave(e) {
            return _this.onStarHoverOut(i, name, e);
          }
        }, _this.renderIcon(i, value, name, id));

        starNodes.push(starNodeLabel);
      };

      for (var i = starCount; i > 0; i--) {
        _loop(i);
      }

      return starNodes.length ? starNodes : null;
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(index, value, name, id) {
      var _this$props5 = this.props,
          renderStarIcon = _this$props5.renderStarIcon,
          renderStarIconHalf = _this$props5.renderStarIconHalf;

      if (typeof renderStarIconHalf === 'function' && Math.ceil(value) === index && value % 1 !== 0) {
        return renderStarIconHalf(index, value, name, id);
      }

      if (typeof renderStarIcon === 'function') {
        return renderStarIcon(index, value, name, id);
      }

      return _react["default"].createElement("i", {
        key: "icon_".concat(id),
        style: {
          fontStyle: 'normal'
        }
      }, "\u2605");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          editing = _this$props6.editing,
          className = _this$props6.className;
      var classes = (0, _classnames["default"])('dv-star-rating', {
        'dv-star-rating-non-editable': !editing
      }, className);
      return _react["default"].createElement("div", {
        style: {
          display: 'inline-block',
          position: 'relative'
        },
        className: classes
      }, this.renderStars());
    }
  }]);

  return StarRatingComponent;
}(_react.Component);

_defineProperty(StarRatingComponent, "propTypes", {
  name: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].number.isRequired,
  editing: _propTypes["default"].bool,
  starCount: _propTypes["default"].number,
  starColor: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onStarClick: _propTypes["default"].func,
  onStarHover: _propTypes["default"].func,
  onStarHoverOut: _propTypes["default"].func,
  renderStarIcon: _propTypes["default"].func,
  renderStarIconHalf: _propTypes["default"].func
});

_defineProperty(StarRatingComponent, "defaultProps", {
  starCount: 5,
  editing: true,
  starColor: '#ffb400',
  emptyStarColor: '#333'
});

var _default = StarRatingComponent;
exports["default"] = _default;
module.exports = exports.default;
